@if (isSeveritySingleMode()) {
  <span [uiBubble]="severityLevel()">{{ severityLevelKey() | translate }}</span>
} @else if (severityThreshold() || severityThreshold() === 0) {
  <div class="f-center">
    <span class="mr-025 aos-severity-circle {{ severityCSSClassModifier() }}"></span>
    <span data-test-id="threshold">{{ severityThreshold() | comma }}</span>
  </div>
}
